import {reducerWithInitialState} from "typescript-fsa-reducers";
import { tableInitialState, deepCopyTableThingyState } from "../typing/tablestates";
import {TableThingyActions} from "../actions/table_actions";

export default reducerWithInitialState(tableInitialState)
        .case(TableThingyActions.resetData, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            if (payload.license){
               deepCopy.model.license = payload.license;
               deepCopy.view.loaded = true;
            }
            return deepCopy;
        })
        ;